import { useEffect, useState } from 'react';

/**
 * The jam countdown.
 *
 * Display only — the server decides when a jam is over and refuses work past the
 * deadline regardless of what this shows. Framed as a jam rather than a limit:
 * the clock running out means "ship it", not "you are in trouble".
 */
export function JamTimer({ endsAt }: { endsAt: number }) {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const remaining = Math.max(0, endsAt - now);
  const minutes = Math.floor(remaining / 60000);
  const seconds = Math.floor((remaining % 60000) / 1000);
  const urgent = remaining < 5 * 60_000 && remaining > 0;

  return (
    <div className={`timer ${urgent ? 'timer--urgent' : ''}`}>
      {remaining === 0 ? (
        <strong>Jam over — shipped! 🚀</strong>
      ) : (
        <>
          <strong>
            {minutes}:{String(seconds).padStart(2, '0')}
          </strong>
          <span>left in this jam</span>
        </>
      )}
    </div>
  );
}
